import { Button } from "@mui/material";

import { useNavigate } from "react-router-dom";
import {useParams } from "react-router-dom";

import deleteApiData from '../../../../../../hooks/apiRequests/deleteRequest';

const DeleteTenant = ({setError}) =>{
    const navigate = useNavigate();
    const { company } = useParams();

    const HandleDelete = async() => {
        try {
            const response = await deleteApiData(`/Delete/Company?CompanyId=${company}`);
            if (response) {
              setError("");
              navigate('/BackOffice/Home');
            } else {
              setError("Company could not deleted");
            }
          } catch (err) {
            console.error("Error processing Delete request:", err);
            setError("Company could not deleted");
          }

    };

    return (
        <Button variant='contained' onClick={HandleDelete} sx={{m:1}}>
            Delete Tenant
        </Button>
    );

};

export default DeleteTenant;